const detailData = {
  // 自有车，招商车和外挂车
  normal: {
    base: {
      label: '基础信息',
      tableData: {
        title: [
          {
            prop: 'trailerNumber',
            label: '车牌号码',
          },
          {
            prop: 'trailerMaterialName',
            label: '挂车材质',
          },
          {
            prop: 'trailerLengthName',
            label: '挂车车长(米)',
          },
          {
            prop: 'trailerLoad',
            label: '挂车载重',
            unit: '吨',
          },
          {
            prop: 'trailerVolume',
            label: '挂车容积',
            unit: '立方',
          },
          {
            prop: 'trailerType',
            label: '车辆类型',
          },
          {
            prop: 'vehicleClassName',
            label: '挂车种类',
          },
          // {
          //   prop: 'vehicleEarlyWarningDay',
          //   label: '行驶证预警天数',
          //   unit: '天',
          // },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    imgInfo: {
      label: '证件信息',
      tableData: {
        title: [
          {
            prop: 'drivingLicense',
            label: '行驶证正本',
            type: 'img',
          },
          {
            prop: 'adriverLicenseCopyObj',
            label: '行驶证副本',
            type: 'img',
          },
          {
            prop: 'drivingLicenseDate',
            label: '行驶证注册日期',
          },
          {
            prop: 'vehicleValidityExpiredTime',
            label: '行驶证失效日期',
          },
          // {
          //   prop: 'carRegistrationPictureUrl',
          //   label: '车辆登记证书图片',
          //   type: 'img',
          // },
          // {
          //   prop: 'vehiclePictureUrl',
          //   label: '车辆图片',
          //   type: 'img',
          // },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    veheicleParams: {
      label: '车辆参数',
      tableData: {
        title: [
          {
            prop: 'vehicleBrandName',
            label: '品牌名称',
          },
          {
            prop: 'brandModelExt',
            label: '品牌型号',
          },
          {
            prop: 'vinNo',
            label: '车架号',
          },
          {
            prop: 'axleNumber',
            label: '轴数',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    location: {
      label: '位置信息',
      tableData: {
        title: [
          {
            prop: 'stateName',
            label: '位置状态',
          },
          {
            prop: 'sourceLocation',
            label: '起始位置',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    // belong: {
    //   label: '归属信息',
    //   tableData: {
    //     title: [
    //       {
    //         prop: 'attachedRootOrgTwoIdName',
    //         label: '归属部门',
    //       },
    //     ],
    //     data: {

    //     },
    //     approveData: {

    //     },
    //   },
    // },
    cost: {
      label: '成本信息',
      tableData: {
        title: [
          {
            prop: 'trailerOwnerShipName',
            label: '车辆性质',
          },
          {
            prop: 'purchaseDate',
            label: '购买时间',
          },
          {
            prop: 'price',
            label: '购车价格',
            unit: '元',
          },
          {
            prop: 'residual',
            label: '残值',
            unit: '元',
          },
          {
            prop: 'depreciatedMonth',
            label: '折旧月数',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
  },
  // 外调车
  outward: {
    base: {
      label: '基础信息',
      tableData: {
        title: [
          {
            prop: 'trailerNumber',
            label: '车牌号码',
          },
          {
            prop: 'trailerMaterialName',
            label: '挂车材质',
          },
          {
            prop: 'trailerLengthName',
            label: '挂车车长(米)',
          },
          {
            prop: 'trailerLoad',
            label: '挂车载重',
            unit: '吨',
          },
          {
            prop: 'trailerVolume',
            label: '挂车容积',
            unit: '立方',
          },
          {
            prop: 'trailerType',
            label: '车辆类型',
          },
          {
            prop: 'vehicleClassName',
            label: '挂车种类',
          },
          // {
          //   prop: 'vehicleEarlyWarningDay',
          //   label: '行驶证预警天数',
          //   unit: '天',
          // },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    imgInfo: {
      label: '证件信息',
      tableData: {
        title: [
          {
            prop: 'drivingLicense',
            label: '行驶证正本',
            type: 'img',
          },
          {
            prop: 'adriverLicenseCopyObj',
            label: '行驶证副本',
            type: 'img',
          },
          {
            prop: 'drivingLicenseDate',
            label: '行驶证注册日期',
          },
          {
            prop: 'vehicleValidityExpiredTime',
            label: '行驶证失效日期',
          },
          // {
          //   prop: 'carRegistrationPictureUrl',
          //   label: '车辆登记证书图片',
          //   type: 'img',
          // },
          // {
          //   prop: 'vehiclePictureUrl',
          //   label: '车辆图片',
          //   type: 'img',
          // },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
  },
};

export default detailData;
